import {
  Block,
  Button,
  CheckCircle,
  HeadingMedium,
  HeadingXSmall,
  useStyletron,
} from "@mezo-org/mezo-clay"

import { SwapFormValue } from "#/shared/types"
import { getMezoExplorerUrl } from "#/shared/utils"

import { useStepperModalContext } from "../StepperModal"

import SwapModalValue from "./SwapModalValue"

export default function SwapModalTransactionSuccess() {
  const { values } = useStepperModalContext<SwapFormValue>()
  const [css, theme] = useStyletron()

  const { tokenIn, tokenOut, transactionHash } = values

  if (!transactionHash) return null

  const explorerLink = getMezoExplorerUrl(transactionHash)

  return (
    <Block
      className={css({
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        marginTop: theme.sizing.scale700,
        textAlign: "center",
        padding: `${theme.sizing.scale800} ${theme.sizing.scale600}`,
        width: "100%",
      })}
    >
      <CheckCircle
        color={theme.colors.contentPositive}
        size={theme.sizing.scale1000}
      />
      <HeadingXSmall margin={`${theme.sizing.scale700} 0`}>
        Transaction sent
      </HeadingXSmall>
      <HeadingMedium marginBottom={theme.sizing.scale900}>
        <SwapModalValue
          amountIn={tokenIn.amount}
          amountOut={tokenOut.amount}
          tokenIn={tokenIn.token}
          tokenOut={tokenOut.token}
        />
      </HeadingMedium>

      <Button
        kind="secondary"
        size="large"
        width="100%"
        $as="a"
        target="_blank"
        href={explorerLink}
      >
        See on Explorer
      </Button>
    </Block>
  )
}
